import { render, staticRenderFns } from "./MoreThanOneRentingEntity.vue?vue&type=template&id=21247899&"
import script from "./MoreThanOneRentingEntity.vue?vue&type=script&lang=ts&"
export * from "./MoreThanOneRentingEntity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports